import { Box } from '@chakra-ui/react';
import React from 'react';
import type { CodeType } from '../../interface/transactionCodes';
import {
  MONO_STACK,
  PILL_CPT_BG,
  PILL_CPT_INK,
  PILL_ICD_BG,
  PILL_ICD_INK,
  PILL_MODIFIER_BG,
  PILL_MODIFIER_INK
} from '../../styles/tokens';

const COLOURS: Record<CodeType, { bg: string; ink: string }> = {
  CPT: { bg: PILL_CPT_BG, ink: PILL_CPT_INK },
  MODIFIER: { bg: PILL_MODIFIER_BG, ink: PILL_MODIFIER_INK },
  ICD: { bg: PILL_ICD_BG, ink: PILL_ICD_INK }
};

export const CodePill: React.FC<{ readonly codeType: CodeType; readonly code: string }> = ({
  codeType,
  code
}) => (
  <Box
    as="span"
    data-testid="code-pill"
    data-code-type={codeType}
    data-code={code}
    fontFamily={MONO_STACK}
    fontSize="12px"
    fontWeight={600}
    borderRadius="4px"
    px="6px"
    py="1px"
    bg={COLOURS[codeType].bg}
    color={COLOURS[codeType].ink}
  >
    {codeType === 'MODIFIER' ? `-${code}` : code}
  </Box>
);
